import { Component } from '@angular/core';
import { ProductosPage } from '../../pages/productos/productos';
import { NavParams, NavController } from 'ionic-angular';
import { PerfilPage } from '../../pages/perfil/perfil';
import { LoginPage } from '../../pages/login/login';
import { CarritoPage } from '../../pages/carrito/carrito';
import { Http } from '@angular/http';
import { CorreoPage } from '../../pages/correo/correo';
import { AlertController } from 'ionic-angular';
import { ReparacionPage } from '../../pages/reparacion/reparacion';

@Component({
  selector: 'header',
  templateUrl: 'header.html'
})
export class HeaderComponent {

  carritoIten;
  codUser;
  language = {};
  btnClose = false;
  correoNew;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public http: Http,public alertCtrl: AlertController) {
    this.http.get('https://ebenlovequickpc.com/i18n/languaje.php?lang='+localStorage.getItem('language')).subscribe((data)=>{
      this.language = data.json();
    })
    this.codUser=(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).CODIGO_USER : 0;
    this.http.get("https://ebenlovequickpc.com/API/carrito.php?cl=select&codigo_user="+this.codUser).subscribe((data)=>{
     let carritoSize=data.json();
     setTimeout(()=>{
       this.carritoIten=carritoSize.length
     },3000);
     
    })
    this.http.get('http://ebenlovequickpc.com/API/correo.php?cl=select-rec&usuario='+this.codUser).subscribe((data)=>{
     //let carritoSize=data.json();
     console.log(data.json())
     setTimeout(()=>{
      // this.correo=carritoSize.length
     },3000);
     
    })
    if(localStorage.getItem("TOKEN")){
      this.btnClose = true;
    }else{
      this.btnClose = false;
    }
  }

  productos(tipo){
    if(tipo == 'RE'){

    }else{
      this.navCtrl.setRoot(ProductosPage,{categoria:tipo});
    }
 }
 user(){
   if(localStorage.getItem("TOKEN")){
     this.navCtrl.setRoot(PerfilPage)
   }else{
     this.navCtrl.push(LoginPage)
   }
 }
carrito(){
  if(localStorage.getItem("TOKEN")){
    this.navCtrl.setRoot(CarritoPage)
  }else{
    this.navCtrl.push(LoginPage)
  }
}
correo(){
  if(localStorage.getItem("TOKEN")){
    this.navCtrl.setRoot(CorreoPage)
  }else{
    this.navCtrl.push(CorreoPage)
  }
}
showRadio() {
  let alert = this.alertCtrl.create();
  alert.setTitle('Lightsaber color');

  alert.addInput({
    type: 'radio',
    label: 'Frances',
    value: 'fr'
  });
  alert.addInput({
    type: 'radio',
    label: 'Ingles',
    value: 'en'
  });
  alert.addInput({
    type: 'radio',
    label: 'Español',
    value: 'es'
  });
  alert.addInput({
    type: 'radio',
    label: 'Creol',
    value: 'cr'
  });

  alert.addButton('Cancel');
  alert.addButton({
    text: 'OK',
    handler: data => {
      localStorage.setItem("language", data);
      window.location.href = '/';
    }
  });
  alert.present();
}

reparar(){
  if(localStorage.getItem("TOKEN")){
      this.navCtrl.setRoot(ReparacionPage)
   }else{
     this.navCtrl.push(LoginPage);
   }
}

closeSecc(){
  localStorage.removeItem("TOKEN");
  localStorage.removeItem("user");
  window.location.href = "./";
}
}



// WEBPACK FOOTER //
// ./src/components/header/header.ts